import React, { useRef, useState, useEffect, useContext } from "react";

import { useSelector, useDispatch } from "react-redux";

import "./style.css";
import { setSearchValue } from "../../modules/search/actions";
import { Theme } from "../../context";

const SearchForm = (props) => {
  const theme = useContext(Theme);

  const dispatch = useDispatch();
  const stateSearchValue = useSelector((state) => state.search.searchValue);

  const {
    callback,
    valueSearch,
    setValueSearch,
    setInputOutRef,
    callbackReset,
    callbackFocus
  } = props;

  const inputRef = useRef(null);
  const themeState = useSelector((state) => state.initData.theme);

  // const [value, setValue] = useState('');

  // useEffect(() => {
  //     // if(valueSearch){
  //         setValue(valueSearch);
  //     // }
  // }, [valueSearch]);

  useEffect(() => {
    if (inputRef && setInputOutRef) {
      setInputOutRef(inputRef);
    }
  }, [inputRef]);

  // useEffect(() => {

  //     dispatch(setSearchValue(value));

  // }, [value])

  const handleChange = (e) => {


    theme.setGlobalSearchValue(e.target.value);
  };

  const handleReset = (e) => {
    e.preventDefault();

    theme.setGlobalSearchValue("");



    if (callbackReset) {
      callbackReset();
    }
  };

  return (
    <div className="search">
      <input
        ref={inputRef}
        type="text"
        className="search__input"
        value={theme.globalSearchValue}
        onFocus={callbackFocus}
        onChange={handleChange}
        placeholder="Поиск"
      />
      {stateSearchValue !== "" && (
        <a
          href="#"
          className="search__reset"
          onClick={(e) => {
            handleReset(e);
          }}
        >
          {((themeState == "dark" || themeState == "light") && (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9999 22C17.5227 22 21.9999 17.5228 21.9999 12C21.9999 6.47715 17.5227 2 11.9999 2C6.47703 2 1.99988 6.47715 1.99988 12C1.99988 17.5228 6.47703 22 11.9999 22ZM7.99988 14.5L10.5857 12.0001L7.99988 9.5L9.49988 8L12 10.5859L14.4999 8L15.9999 9.5L13.4142 12.0001L15.9999 14.5L14.4999 16L12 13.4143L9.49988 16L7.99988 14.5Z"
                fill="#4F4F52"
              />
            </svg>
          )) || (
            <img src="https://cdn.podeli.ru/web-catalog/assets/img/icon-reset-search.svg" />
          )}
        </a>
      )}
    </div>
  );
};

export default SearchForm;
